import { builder } from 'common/js/configs';
import { units } from 'common/js/configs/constants';

const getConfiguration = function({
  primaryColor,
  secondaryColor,
  useBackgroundShading
}: {
  primaryColor: string;
  secondaryColor: string;
  useBackgroundShading: boolean;
}) {
  return {
    background: builder.holder({
      primaryColor: builder.color('background_primary_color', {
        defaultValue: primaryColor || '#FFFFFF',
        l:'',
        d:''
      }),
      secondaryColor: builder.color('background_secondary_color', {
        defaultValue: secondaryColor || '#FFFFFF',
        l:'',
        d:''
      }),
      shade: builder.number('background_shade', {
        defaultValue: 100,
        l:'',
        d:'',
        min: -100,
        max: 100,
        unit: units.percentage
      }),
      useBackgroundShading: builder.boolean('background_use_shading', {
        defaultValue: useBackgroundShading,
        l:'',
        d:''
      })
    })
  };
};

export const backgroundWhite = getConfiguration({
  primaryColor: '#FFFFFF',
  secondaryColor: '#FFFFFF',
  useBackgroundShading: true
});

export const backgroundTransparent = getConfiguration({
  primaryColor: 'rgba(0, 0, 0, 0)',
  secondaryColor: 'rgba(0, 0, 0, 0)',
  useBackgroundShading: false
});
